import { render, staticRenderFns } from "./EmailWhitelabeling.vue?vue&type=template&id=3b7b61ae"
import script from "./EmailWhitelabeling.vue?vue&type=script&lang=js"
export * from "./EmailWhitelabeling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports